import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { EnvelopeIcon, PhoneIcon, PlayIcon } from "@heroicons/react/24/solid";
import React from "react";

const TravelHelp = () => {
  const tutorials = [
    {
      title: "End to End Booking",
      description: "Complete step-by-step guide on how to book a full business trip from start to finish.",
      duration: "4:32",
      color: "from-blue-400 to-indigo-600",
    },
    {
      title: "Travel Requests",
      description: "Learn how to submit and manage travel requests efficiently.",
      duration: "2:18",
      color: "from-emerald-400 to-teal-600",
    },
    {
      title: "Flights",
      description: "How to search, compare, and book flights using our platform.",
      duration: "3:45",
      color: "from-amber-400 to-orange-600",
    },
    {
      title: "End to End Booking",
      description: "Complete step-by-step guide on how to book a full business trip from start to finish.",
      duration: "4:32",
      color: "from-pink-400 to-rose-600",
    },
    {
      title: "Travel Requests",
      description: "Learn how to submit and manage travel requests efficiently.",
      duration: "2:18",
      color: "from-purple-400 to-violet-600",
    },
    {
      title: "Flights",
      description: "How to search, compare, and book flights using our platform.",
      duration: "3:45",
      color: "from-yellow-400 to-lime-600",
    },
  ];

  return (
    <div className="mx-auto max-w-[1300px] px-8 pb-10 pt-12">
      <h1 className="mb-12 text-center text-5xl font-semibold text-[#572f5f]">How Can We Help You Today?</h1>

      <div className="flex items-start gap-10">
        <div className="sticky top-8 w-96 flex-shrink-0 rounded-2xl border border-gray-100 bg-white p-8 shadow">
          <div className="mb-8">
            <h2 className="flex items-start gap-3 text-xl font-semibold text-gray-800">Has Anything Changed? Let Us Know!</h2>
            <div className="mt-4 text-base leading-relaxed text-gray-600">To ensure your travel arrangements are always up to date, please keep your passport details and travel profile information current in your account.</div>
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="mb-2 font-semibold text-gray-800">Office Hours</h3>
              <div className="text-gray-600">Monday – Friday: 9:00 AM – 5:30 PM (GMT)</div>
              <div className="mt-1 font-semibold text-emerald-600">24/7 Emergency Support Available</div>
            </div>

            <div>
              <h3 className="mb-2 font-semibold text-gray-800">Contact Us</h3>
              <div className="flex flex-col gap-2">
                <a
                  href="tel:+441892616122"
                  className="flex items-center justify-center gap-3 rounded-xl border border-black/5 bg-[#f5f0fd] px-6 py-4 font-medium transition-all hover:shadow-md">
                  <PhoneIcon className="h-5 w-5 text-[#744773]" />
                  +44 (0)1892 616 122
                </a>

                <a
                  href="mailto:enquire@ctbusinesstravel.co.uk"
                  className="flex items-center justify-center gap-3 rounded-xl border border-black/5 bg-[#f5f0fd] px-6 py-4 font-medium transition-all hover:shadow-md">
                  <EnvelopeIcon className="h-5 w-5 text-[#744773]" />
                  enquire@ctbusinesstravel.co.uk
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-shrink flex-grow py-2">
          <h2 className="mb-2 flex items-start gap-3 text-3xl font-extrabold text-gray-800">Video Tutorials</h2>

          <div className="divide-y divide-black/5">
            {tutorials.map((tutorial, index) => (
              <div
                key={index}
                className="group flex min-w-full gap-5 px-1 py-4">
                {/* Video Thumbnail */}
                <div className="relative h-32 w-48 flex-shrink-0 overflow-hidden rounded-2xl bg-gradient-to-br shadow transition-all duration-300 group-hover:shadow-lg">
                  <div className={`absolute inset-0 bg-gradient-to-br ${tutorial.color} opacity-90`} />
                  {/* Play Button */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/50 text-black/80 shadow transition-all duration-300 group-hover:scale-110">
                      <PlayIcon className="h-5 w-5" />
                    </div>
                  </div>

                  {/* Duration */}
                  <div className="absolute bottom-2 left-2 rounded-lg bg-black/50 px-3 py-1 text-xs font-medium text-white">{tutorial.duration}</div>
                </div>

                {/* Content */}
                <div className="flex-1 pt-2">
                  <h3 className="text-lg font-extrabold tracking-wide text-gray-800 transition-colors group-hover:text-[#744773]">{tutorial.title}</h3>
                  <div className="mt-3 text-base leading-relaxed text-gray-600">{tutorial.description}</div>
                  <button className="mt-5 flex items-center gap-2 text-sm font-semibold text-[#744773] transition-colors hover:text-[#572f5f]">
                    Watch Video
                    <ArrowRightIcon className="h-4 w-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelHelp;
